/* ============================================================
   OBA — front-end gedrag (vanilla JS, geen dependencies)
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ---- nav schaduw bij scrollen + hero parallax ---- */
    var nav = document.querySelector('.oba-nav');
    var hero = document.getElementById('oba-hero-photo');
    if (hero) { hero.style.transform = 'scale(1.12)'; hero.style.willChange = 'transform'; }
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (nav) nav.classList.toggle('is-scrolled', y > 24);
      if (hero && y < 1100) hero.style.transform = 'scale(1.12) translate3d(0,' + (y * 0.06) + 'px,0)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---- scroll reveal ---- */
    if ('IntersectionObserver' in window) {
      var targets = [];
      document.querySelectorAll('[data-rv]').forEach(function (el) { el.classList.add('oba-rv'); targets.push(el); });
      document.querySelectorAll('[data-rv-stagger]').forEach(function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          child.classList.add('oba-rv');
          child.style.transitionDelay = (Math.min(i, 9) * 65) + 'ms';
          targets.push(child);
        });
      });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('oba-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('[data-rv], [data-rv-stagger] > *').forEach(function (el) { el.classList.add('oba-in'); });
    }

    /* ---- account dropdown ---- */
    document.querySelectorAll('[data-account-root]').forEach(function (root) {
      var trigger = root.querySelector('[data-account-toggle]');
      var panel = root.querySelector('[data-account-panel]');
      if (!trigger || !panel) return;
      var open = false;
      function set(v) {
        open = v;
        panel.style.opacity = v ? '1' : '0';
        panel.style.transform = v ? 'translateY(0)' : 'translateY(-6px)';
        panel.style.visibility = v ? 'visible' : 'hidden';
        panel.style.pointerEvents = v ? 'auto' : 'none';
      }
      set(false);
      trigger.addEventListener('click', function (e) { e.preventDefault(); set(!open); });
      document.addEventListener('click', function (e) {
        if (!open) return;
        if (root.contains(e.target)) return;
        set(false);
      });
    });

    /* ---- cursussen tabs ---- */
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('[data-tab]');
      var panels = wrap.querySelectorAll('[data-tabpanel]');
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-tab');
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-tabpanel') !== key; });
        });
      });
    });

    /* ---- sticky buy bar (productpagina) ---- */
    var stickyBar = document.querySelector('[data-sticky-bar]');
    if (stickyBar) {
      var onStick = function () {
        var show = (window.scrollY || window.pageYOffset) > 620;
        stickyBar.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
      };
      window.addEventListener('scroll', onStick, { passive: true });
      onStick();
    }

    /* ---- accordion (modules / faq) ---- */
    document.querySelectorAll('[data-accordion] [data-acc-item]').forEach(function (item) {
      var btn = item.querySelector('[data-acc-trigger]');
      var body = item.querySelector('[data-acc-body]');
      var sign = item.querySelector('[data-acc-sign]');
      if (!btn || !body) return;
      body.style.maxHeight = '0px';
      body.style.overflow = 'hidden';
      body.style.transition = 'max-height .35s ease';
      btn.addEventListener('click', function () {
        var open = body.style.maxHeight !== '0px' && body.style.maxHeight !== '';
        if (open) { body.style.maxHeight = '0px'; if (sign) sign.textContent = '+'; }
        else { body.style.maxHeight = body.scrollHeight + 40 + 'px'; if (sign) sign.textContent = '\u2212'; }
      });
    });

    /* ---- reviews carousel ---- */
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-car-track]');
      var slides = track ? track.children : [];
      var dotsWrap = root.querySelector('[data-car-dots]');
      var prev = root.querySelector('[data-car-prev]');
      var next = root.querySelector('[data-car-next]');
      if (!track || slides.length === 0) return;

      var idx = 0, timer = null;

      function perView() {
        var w = window.innerWidth || 1280;
        return w <= 680 ? 1 : (w <= 1040 ? 2 : 3);
      }
      function maxIdx() { return Math.max(0, slides.length - perView()); }

      function render() {
        var pv = perView();
        for (var i = 0; i < slides.length; i++) {
          slides[i].style.flex = '0 0 ' + (100 / pv) + '%';
        }
        idx = Math.min(idx, maxIdx());
        track.style.transform = 'translateX(-' + (idx * (100 / pv)) + '%)';
        if (dotsWrap) {
          dotsWrap.innerHTML = '';
          for (var d = 0; d <= maxIdx(); d++) {
            (function (n) {
              var b = document.createElement('button');
              b.className = 'oba-dot' + (n === idx ? ' is-active' : '');
              b.setAttribute('aria-label', 'Ga naar review ' + (n + 1));
              b.addEventListener('click', function () { idx = n; render(); restart(); });
              dotsWrap.appendChild(b);
            })(d);
          }
        }
      }
      function go(delta) { idx = Math.max(0, Math.min(maxIdx(), idx + delta)); render(); }
      function restart() { if (timer) clearInterval(timer); timer = setInterval(function () { idx = idx >= maxIdx() ? 0 : idx + 1; render(); }, 6000); }

      if (prev) prev.addEventListener('click', function () { go(-1); restart(); });
      if (next) next.addEventListener('click', function () { go(1); restart(); });
      window.addEventListener('resize', function () { idx = 0; render(); }, { passive: true });
      render();
      restart();
    });

  });
})();